function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.94 1.25H12.5V.5a.5.5 0 00-1 0v.75h-7V.5a.5.5 0 00-1 0v.75H2.06A2.07 2.07 0 000 3.31v10.63A2.07 2.07 0 002.06 16h11.88A2.07 2.07 0 0016 13.94V3.31a2.07 2.07 0 00-2.06-2.06zm-11.88 1H3.5v.5a.5.5 0 001 0v-.5h7v.5a.5.5 0 001 0v-.5h1.44A1.07 1.07 0 0115 3.31V4.5H1V3.31a1.07 1.07 0 011.06-1.06zM13.94 15H2.06A1.07 1.07 0 011 13.94V5.5h14v8.44A1.07 1.07 0 0113.94 15z"
});

function SvgCalendar(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/calendar.541082ce.svg";
export { SvgCalendar as ReactComponent };